import React from 'react';
import { getLongestInvoiceSummaryAmountLength } from '@finance-hub/domain/invoicing/blocs/utils/invoice-summary-amount-size-utils';
import { InvoiceSummary } from '@finance-hub/domain/invoicing/blocs/types/invoice-summary';
import { InvoiceSummaryAmountBucketCard } from '@finance-hub/domain/invoicing/components/invoice-summary-amount-bucket-card';
import { InvoiceSummaryBucketFilter } from '@finance-hub/domain/invoicing/blocs/types/unpaid-invoice-filters';
import { InvoiceSummaryTimeSeriesBucketCard } from '@finance-hub/domain/invoicing/components/invoice-summary-time-series-bucket-card';
import { isInvoiceSummaryBucketFilterSelected } from '@finance-hub/domain/invoicing/blocs/utils/invoice-summary-bucket-filter-utils';
import { XStack } from '@usepepper/sprout-kit-ui';

interface Props {
  onSelectFilter: (filter: InvoiceSummaryBucketFilter) => void;
  selectedFilter: InvoiceSummaryBucketFilter;
  summary: InvoiceSummary;
}

export const InvoiceSummaryBucketsRow: React.FC<Props> = ({
  onSelectFilter,
  selectedFilter,
  summary,
}) => {
  const { amountBuckets, timeSeriesBuckets } = summary;
  const longestAmountLength = getLongestInvoiceSummaryAmountLength(summary);

  const getInteractionState = (filter: InvoiceSummaryBucketFilter) =>
    isInvoiceSummaryBucketFilterSelected(filter, selectedFilter)
      ? 'active'
      : 'inactive';

  return (
    <XStack flexWrap="wrap" gap="$12" width="100%">
      {amountBuckets.map((bucket) => (
        <InvoiceSummaryAmountBucketCard
          amount={bucket.amount}
          countLabel={bucket.countLabel}
          interactionState={getInteractionState(bucket.filter)}
          key={bucket.label}
          label={bucket.label}
          longestAmountLength={longestAmountLength}
          onPress={() => onSelectFilter(bucket.filter)}
          variant={bucket.variant}
        />
      ))}
      {timeSeriesBuckets.map((bucket) => (
        <InvoiceSummaryTimeSeriesBucketCard
          amount={bucket.amount}
          countLabel={bucket.countLabel}
          interactionState={getInteractionState(bucket.filter)}
          key={bucket.label}
          label={bucket.label}
          longestAmountLength={longestAmountLength}
          onPress={() => onSelectFilter(bucket.filter)}
          variant={bucket.variant}
        />
      ))}
    </XStack>
  );
};
